<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M9.2 5.399a3.806 3.806 0 0 1-3.8 3.798 3.798 3.798 0 1 1 0-7.597c2.093 0 3.8 1.706 3.8 3.799m2.573 6.371a.866.866 0 0 0 .227-.573c0-.2-.08-.413-.24-.56L9.747 8.611a5.372 5.372 0 0 0 1.066-3.212C10.813 2.426 8.387 0 5.4 0A5.402 5.402 0 0 0 0 5.399a5.41 5.41 0 0 0 5.4 5.398c1.2 0 2.307-.387 3.213-1.053l2.027 2.026a.813.813 0 0 0 1.133 0"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
